import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function ConsView(props){
  const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
  const [rows, setRows] = useState([]);
  const [opData, setOpData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchData();
    const intervalId = setInterval(fetchData, 15000); // Fetch data every 5 seconds
    return () => clearInterval(intervalId); // Cl
  }, [selectedDate]);

  useEffect(() => {
      if (opData.length > 0) {
        setRows(opData);
      }
  }, [opData]);
  function fetchData() {
  setIsLoading(true);
  const formattedDate = selectedDate.toISOString().substring(0, 10);
  axios
    .get(`${baseUrl}op-cons-view/${formattedDate}/`)
    .then((response) => {
      if (response.data.length > 0) {
        const filteredData = response.data.filter(
          (item) => item.cons__consultant === userName
        );
        if (filteredData.length > 0) {
          setOpData(filteredData);
        } else {
          console.log("No data found for the logged-in user.");
        }
      } else {
        console.log("No data found in the response.");
      }
      setIsLoading(false);
    })
    .catch((error) => {
      console.log(error);
      setIsLoading(false);
    });
}

  const handleDateChange = (date) => {
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    setSelectedDate(localDate);
  };

  const columns = [
    { field: 'appt_id', headerName: 'Appt Id', width: 200},
    { field: 'pat__pat_id', headerName: 'Patient ID', width: 200},
    { field: 'pat__patient', headerName: 'Patient', width: 200 },

    { field: 'addedby', headerName: 'Added by', width: 150 },
    { field: 'add_date_date', headerName: 'Appt Slot', width: 150 },
    { field: 'action', headerName: 'Action',
      renderCell: (params) => (
          <Link to={`/cons-detail/${params.row.id}`} className="btn btn-success">
            View
          </Link>
      ),
    width: 100 },
  ];

  return (
    <section className="container mt-4">
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
            <div className="col-sm-9 col-lg-10 controls">
              <DatePicker selected={selectedDate} onChange={handleDateChange} dateFormat="dd/MM/yyyy" />
            </div>
          </div>
        </div>
      </div>

      {!isLoading && opData.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }} className="mt-4">
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={rows}
            columns={columns}
            pageSize={10}
            slots={{ toolbar: GridToolbar }}
            autoHeight
          />
        </div>
      ) : (
        <></>
      )}
    </section>
  )
}

export default ConsView;
